export const setLocalStorage = (data, key = "categoryGrid") => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getLocalStorage = (key = "categoryGrid") => {
  return JSON.parse(localStorage.getItem(key));
};

export const clearLocalStorage = () => {
  localStorage.removeItem("categoryGrid");
};
